/*
 * contact-uae translations for the "en" locale.
 *
 * Split out of locales/en.js so this feature's copy stops shipping to
 * every route in the app. See locales/contact-uae/index.js.
 */
export default {
    banner: {
      title: (
        <>
          <h1>Go Beyond The Borders With Contact!</h1>
          <br />
          <h2>Buy In Egypt, And Pay From UAE</h2>
        </>
      ),
      description: (
        <>
          <p>
            Contact has been at the forefront of transforming consumer finance
            in Egypt. By introducing innovative "buy now, pay later" solutions,
            we have empowered countless Egyptians to achieve their dreams and
            manage their finances more effectively. As the nation's leading
            provider of customized financial products for almost 25 years now,
            Contact continues to set the standard for excellence and innovation
            in the industry.
          </p>
          <p>
            We are extending our unparalleled commitment to Egyptians residing
            in the United Arab Emirates. With Contact, you can seamlessly
            purchase anything in Egypt and pay from the UAE, leveraging our
            comprehensive and diversified financing and insurance portfolio.
            Enjoy the convenience and flexibility of managing your financial
            needs across borders with the trusted support of Contact.
          </p>
        </>
      ),
    },
    second_section: {
      title: "We Finance Almost Everything You Might Need!",
      description:
        "Contact offers a wide range of financing and insurance services to cover all your needs in Egypt, including:",
      list: [
        { name: "Auto Financing", url: "/products/auto" },
        { name: "Motorcycle Financing", url: "/products/motorcycles" },
        { name: "Truck Financing", url: "/products/trucks" },
        { name: "Home Furniture Financing", url: "/products/home-furniture" },
        { name: "Home Interior Financing", url: "/products/home-interior" },
        { name: "Green Finance", url: "/products/green-finance" },
        { name: "Maintenance Financing", url: "/products/maintainance" },
        { name: "Manasik", url: "/products/travel-and-tourism" },
        { name: "Club Memberships", url: "/products/clubs" },
        { name: "Education Financing", url: "/products/education" },
        { name: "Shopping", url: "/products/contact-now" },
        { name: "Insurance Services", url: "/products/insurance" },
        { name: "Watercraft Financing", url: "/products/watercraft" },
      ],
    },
    third_section: {
      title: "Contact Is Near To You In UAE!",
      description:
        "At Contact, we understand the unique needs of Egyptians living in the UAE and are dedicated to providing them with seamless access to our top-notch financial and insurance services. Our goal is to make managing your finances as convenient and stress-free as possible, whether you're in Egypt or the UAE. Here's what you can expect when you choose Contact:",
      list: [
        "Diverse Financing and Insurance Solutions: Enjoy the same wide range of services available in the Egyptian market.",
        "From The Convenience Of Your Home: No need to travel back to Egypt. Apply for our financing or insurance products from the comfort of your home in the UAE.",
        "Speed of Service: Benefit from simple, fast procedures with minimal paperwork.",
        "Flexible Payment Options: Spread the cost of your purchases with our flexible payment plans, giving you more control over your finances.",
        "Dedicated Customer Support: Our committed team of experts provides professional support and guidance throughout your financing and insurance journey, whether you are in Egypt or the UAE.",
      ],
    },
    form: {
      title: "How To Apply?",
      subTitle1:
        "Fill out the form and one of our representatives will contact you",
      subTitle2:
        "Apply now and experience a new era of financial solutions with Contact!",
      name: "Full Name",
      email: "Email Address",
      national_id: "National ID Number",
      phone_number: "Phone Number",
      product: "Product",
      product_list_name: "Choose product",
      product_list: [
        { id: 1, product_name: "Auto", value: "auto" },
        { id: 2, product_name: "Trucks", value: "trucks" },
        { id: 3, product_name: "Shopping", value: "shopping" },
        { id: 4, product_name: "Education", value: "education" },
        { id: 5, product_name: "Clubs", value: "clubs" },
        { id: 6, product_name: "Maintenance", value: "maintaince" },
        { id: 7, product_name: "Motorcycles", value: "21" },
        { id: 9, product_name: "Mortgage", value: "mortgage" },
        { id: 10, product_name: "Green finance", value: "greenFinance" },
        { id: 11, product_name: "Home furniture", value: "19" },
        { id: 12, product_name: "Home Interior", value: "homes" },
        { id: 13, product_name: "Watercraft", value: "20" },
        { id: 14, product_name: "Manasik", value: "manasik" },
        {
          id: 15,
          product_name: "Insurance Brokerage",
          value: "brokerage",
        },

        ,
      ],
      message: "Message",
      submit: "Send",
    },
    last_section: {
      contact_us: "Contact us",
      list: [
        {
          title: "Telephone",
          description: "Call us for immediate assistance!",
          info: (
            <>
              <a
                href="tel:+971 54 700 4400"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  marginBottom: "10px",
                  display: "block",
                }}
              >
                +971 54 700 4400
              </a>
              <a
                href="tel:+971 50 865 3388"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                +971 50 865 3388
              </a>
            </>
          ),
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/phone-icon-uae.png",
        },
        {
          title: "E-mail",
          description: "Send your inquiry via e-mail for support!",
          info: "Info@contact.eg",
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/email-icon-uae.png",
        },

        {
          title: "Location",
          description: "Visit our branch in UAE",
          info: (
            <a
              target="_blank"
              href="https://maps.app.goo.gl/wPXEt4zWJrxrgC3p6?g_st=awb"
              style={{ textDecoration: "underline", color: "inherit" }}
            >
              Tamanai Arts Office, Business Bay - Office No. 1806
            </a>
          ),
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/location-icon-uae.png",
        },
      ],
    },
  };
